<template>
  <section
    class="period1995-1999wrap"
    v-parallax
    :key="$route.name"
    :data-key="$route.name"
  >
    <v-page
      background="/images/spread-of-kingdom-gospel/index/spread-of-kingdom-gospel-bg-preload.jpg"
      v-parallax-background
      class="page-index"
      v-skip="$route.name"
      v-slide-up-in
    >
      <v-chapter-title
        :chapTip="firstPageData.episode"
        :chapterTitle="chapterTitle"
        :stageTitle="firstPageData.stage"
        v-slide-up-in-stage="1"
        v-if="chapterTitle"
      >
        <v-stage-cards
          v-for="(item, i) in childrenNavData"
          :key="i"
          :images="poster(item.path)"
          :title="item.title"
          :slug="item.path"
          :count="childrenNavData.length"
        />
      </v-chapter-title>
      <v-text-content
        :html="pageDataItem.index.data.content"
        v-slide-up-in-stage="2"
      />
    </v-page>

    <v-page :background="theme.colors.cyan" v-slide-up-in>
      <v-chapter-years-title :pageData="info" v-slide-up-in-stage="1" />
      <v-picture-wall :data="pictures.data" v-slide-up-in-stage="1" />
    </v-page>

    <v-page v-if="books" :background="theme.colors.cyan">
      <v-books :books="books" />
      <v-chatper-entry class="margin0" />
    </v-page>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("global", ["schema"]),
  },
  data() {
    return {
      pageDataItem: {},
      books: "",
      info: "",
      pictures: "",
      chapterTitle: "",
      childrenNavData: [],
    };
  },
  created() {
    this.chapterTitle = this.schema.global.item[
      "spread-of-kingdom-gospel"
    ].title;

    this.firstPageData = this.schema.global.item.aside.data[6];
    this.childrenNavData = this.schema.global.item.aside.data[6].children;

    this.pageDataItem = this.schema[this.get_router_name()].item;
    this.books = this.pageDataItem.books;
    this.info = this.pageDataItem.info;
    this.pictures = this.pageDataItem.pictures;
  },
  methods: {
    poster(path) {
      return `images/home/thumb/${path}.jpg`;
    },
  },
};
</script>

<style lang="scss">
.period1995-1999wrap .page-index {
}
</style>
